import { QBankStructureDashBoard } from '@exam-management/qbank-structure-detail';
import { Box } from '@shared/components';

export default function DashboardPage() {
  return (
    <Box sx={{ p: (theme) => theme.spacing(6) }}>
      <QBankStructureDashBoard />
    </Box>
  );
}
